import React from 'react'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

const MyDocumentBreadcrumb = ({ breadcrumb = [], onNavigate }) => {
  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <a onClick={() => onNavigate('')}>
          <HomeOutlined />
        </a>
      </Breadcrumb.Item>
      {breadcrumb.map((item, index) => (
        <Breadcrumb.Item key={item.id}>
          {index === breadcrumb.length - 1 ? (
            <span>{item.name}</span>
          ) : (
            <a onClick={() => onNavigate(item.id)}>{item.name}</a>
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default MyDocumentBreadcrumb
